import { useCallback } from 'react';
import type { UserPreferences } from '../storage/userPreferences';
import { useUserPreference } from './useUserPreference';

/** Zobrazení seznamu účtů na dashboardu. */
export type DashboardView = UserPreferences['dashboardView']['view'];

/**
 * Volba zobrazení dashboardu (standardní/kompaktní + účty všech firem).
 *
 * Hodnoty žijí ve sdíleném per-user úložišti (viz
 * `storage/userPreferences`), tenhle hook je jen pojmenovaný přístup k nim.
 * Až backend rozšíří `/user/preferences` o zobrazení tabulky, přepne se
 * zdroj v úložné vrstvě a volající se nezmění.
 */
export function useDashboardViewPreference(userId?: number) {
  const [preference, update] = useUserPreference(userId, 'dashboardView');

  const setView = useCallback(
    (view: DashboardView) => update({ view }),
    [update],
  );

  const setAllClients = useCallback(
    (allClients: boolean) => update({ allClients }),
    [update],
  );

  /** Prázdný řetězec = bez omezení na měnu. */
  const setCurrency = useCallback(
    (currency: string) => update({ currency }),
    [update],
  );

  return { ...preference, setView, setAllClients, setCurrency };
}
